import { connect } from 'react-redux';

import { selectProductEntity } from 'app/selectors/AnalyticsGa4Selector';
import AuthorLink from './AuthorLink';

const mapStateToProps = state => ({ analyticsProductId: selectProductEntity(state)?.get('product_id') });

export default connect(mapStateToProps)(AuthorLink);
